module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('h1', [_vm._v("Modal Example")]), _vm._v(" "), _c('row', [_c('div', {
    staticClass: "col-md-12"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-lg",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.openModal
    }
  }, [_vm._v("\n        Launch demo modal\n      ")])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-20317a96!./~/vue-loader/lib/selector.js?type=template&index=0!./src/examples/ModalExample.vue
// module id = 498
// module chunks = 1